import { call, takeLatest } from "redux-saga/effects";
import { SUPPORT_CREATE } from "../actions/types";
import { SupportApi } from "../apis/supportApi";


export function* supportCreateWorker(action) {
  try {
    const res = yield call(SupportApi, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
      console.log(res.data);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* supportCreateWatcher() {
  yield takeLatest(SUPPORT_CREATE, supportCreateWorker);
}
